import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, Star } from 'lucide-react';
export function Hero() {
  const scrollToOffers = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const offersSection = document.getElementById('comprar');
    if (offersSection) {
      const headerHeight = 56;
      // Adjusted offset - scroll a bit lower to show offers better
      const isMobile = window.innerWidth < 768;
      const offset = isMobile ? -10 : 50;
      const elementPosition = offersSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  const scrollToWhatIncludes = (e: React.MouseEvent) => {
    e.preventDefault();
    const includesSection = document.getElementById('que-incluye');
    if (includesSection) {
      const headerHeight = 56;
      const offset = 20;
      const elementPosition = includesSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <div className="relative min-h-[100vh] flex items-center justify-center overflow-hidden pt-28 pb-20" data-id="element-130">
      {/* Background Image - Optimized with loading priority */}
      <div className="absolute inset-0 z-0" data-id="element-131">
        <img src="https://cdn.magicpatterns.com/uploads/aJf41FQwboJzBR3Vjzn7Jt/heylloyd-image-1771887430714.png" alt="Dance Studio Background" className="w-full h-full object-cover" loading="eager" fetchPriority="high" data-id="element-132" />
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900/70 via-black/65 to-pink-900/70" data-id="element-133" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center text-white max-w-4xl flex flex-col items-center" data-id="element-134">
        <div className="inline-flex items-center gap-1.5 bg-pink-600/20 backdrop-blur-sm border border-pink-500/50 rounded-full px-3.5 py-1.5 mb-5" data-id="element-135">
          <Star className="w-3.5 h-3.5 text-pink-400 fill-pink-400" data-id="element-136" />
          <span className="text-pink-200 font-medium text-xs tracking-wide uppercase" data-id="element-137">
            El recurso #1 para docentes de danza
          </span>
          <Star className="w-3.5 h-3.5 text-pink-400 fill-pink-400" data-id="element-138" />
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold mb-5 leading-tight drop-shadow-lg" data-id="element-139">
          MegaPack Danza Lista: <br data-id="element-140" />
          <span className="text-pink-400" data-id="element-141">Planificación Total</span>
        </h1>

        {/* Product Image Mockup - Optimized */}
        <div className="relative w-full max-w-[200px] mx-auto perspective-1000 mb-5" data-id="element-142">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-pink-500/30 blur-[80px] rounded-full opacity-50 animate-pulse-slow" data-id="element-143" />

          <img src="https://cdn.magicpatterns.com/uploads/eydcyVhNk6AQdzWLvAZoEE/Diseno_sin_titulo_(10).png" alt="MegaPack Danza Lista - 6 Módulos Completos" className="relative z-10 w-full h-auto drop-shadow-2xl" loading="eager" fetchPriority="high" style={{
          animation: 'float 6s ease-in-out infinite',
          filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.6))'
        }} data-id="element-144" />
        </div>

        <p className="text-lg md:text-xl text-gray-200 mb-7 max-w-2xl mx-auto leading-relaxed" data-id="element-145">
          Clases listas para dar, organizadas por niveles y edades. De Baby
          Dance hasta Adultos. Transformá tus clases hoy mismo.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center w-full" data-id="element-146">
          <a href="#comprar" onClick={scrollToOffers} className="w-full sm:w-auto" data-id="element-147">
            <Button size="lg" variant="primary" className="w-full sm:w-auto text-lg px-8 py-4" data-id="element-148">
              Adquirir Ahora
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-149" />
            </Button>
          </a>
          <a href="#que-incluye" onClick={scrollToWhatIncludes} className="w-full sm:w-auto" data-id="element-150">
            <Button size="lg" variant="outline" className="w-full sm:w-auto text-lg px-8 py-4 bg-white/10 hover:bg-white/20 border-white/30 backdrop-blur-sm" data-id="element-151">
              Más Información
            </Button>
          </a>
        </div>
      </div>

      <style data-id="element-152">{`
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
          100% { transform: translateY(0px); }
        }
        @keyframes pulse-slow {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 0.5; }
        }
        .animate-pulse-slow {
          animation: pulse-slow 4s ease-in-out infinite;
        }
      `}</style>
    </div>;
}